module.exports = __webpack_public_path__ + "static/media/blackV.83f23978.svg";